import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";

import AppRoutes from "../routes/Routes";
import { setCurrentLang } from "../store/Lang/actions";
import Theme from "../utils/Theme";
import Snackbar from "./../components/Snackbar";
import Loader from "./../components/Loader";
import { setupNotifications } from "../notifications/firebase";
import { getUnseenNotificationsCountRequest } from "../store/Notifications/actions";
import "./App.scss";

const App = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.locale.lang);
  const isAuth = useSelector((state) => state.auth.login?.Token);

  useEffect(() => {
    dispatch(setCurrentLang(lang));
    document.dir = lang === "en" ? "ltr" : "rtl";
  }, [dispatch, lang]);

  useEffect(() => {
    setupNotifications();
    if (isAuth) {
      dispatch(getUnseenNotificationsCountRequest());
    }
  }, [isAuth]);

  return (
    <>
      <ThemeProvider theme={Theme}>
        <AppRoutes />
        <Snackbar />
      </ThemeProvider>
      <Loader />
    </>
  );
};

export default App;
